import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import CheckIcon from './CheckIcon.vue';
import { planFeatures } from '~/data/plan_features';
import { ExtendedPlan } from '~/data/plans';
import { useLocale } from '~/composables/useLocale';

export interface PlansDetailsV2Props {
  plans: ExtendedPlan[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlansDetails',
  props: {
    plans: null
  },
  setup(__props: any) {

const { $isFlagOn } = useContext();
const locale = useLocale();

const displayPlan = (plan: ExtendedPlan): boolean =>
  plan.hideFromDetailsTable !== true &&
  (($isFlagOn('school-plan-discount') &&
    plan.code !== 'essential_annual' &&
    locale.value === 'au') ||
    ($isFlagOn('school-plan-discount') && locale.value !== 'au') ||
    (!$isFlagOn('school-plan-discount') && plan.code !== 'school_plan'));


const features = {
  au: [
    {
      name: 'Curated Resource Bundles',
      items: planFeatures[locale.value].resourceBundles,
    },
    {
      name: 'Advanced Tools',
      items: planFeatures[locale.value].advancedTools,
    },
    {
      name: 'File Formats',
      items: planFeatures[locale.value].resourceFormats,
    },
  ],
  us: [
    {
      name: 'Plan Capabilities',
      items: planFeatures[locale.value].downloads,
    },
    {
      name: 'Curated Resource Bundles',
      items: planFeatures[locale.value].resourceBundles,
    },
    {
      name: 'Advanced Tools',
      items: planFeatures[locale.value].advancedTools,
    },
    {
      name: 'File Formats',
      items: planFeatures[locale.value].resourceFormats,
    },
  ],
  gb: [
    {
      name: 'Curated Resource Bundles',
      items: planFeatures[locale.value].resourceBundles,
    },
    {
      name: 'Advanced Tools',
      items: planFeatures[locale.value].advancedTools,
    },
    {
      name: 'File Formats',
      items: planFeatures[locale.value].resourceFormats,
    },
  ],
};

const alternativeFeatureLabels = (value: string[]) => {
  if (value.length > 0) {
    return value.find(i => i === 'free_limited' || i === 'essential_limited') !== undefined
      ? 'Limited'
      : value.find(i => i === 'free_view' || i === 'essential_view') !== undefined
        ? 'View Only'
        : undefined;
  }
  return undefined;
};

return { __sfc: true,$isFlagOn, locale, displayPlan, features, alternativeFeatureLabels, CheckIcon }
}

})